import dayjs from 'dayjs';
import { TGetProductsOfMonthForm } from '../helpers';
import { DateFormats } from '@/constants/dates';
import { IUpdateProductsOfMonthDTO } from '@/models/products.model';

class CreateProductDTO implements IUpdateProductsOfMonthDTO {
  product_id: string;
  published: '0' | '1';
  date_to: string;
  date_from: string;

  constructor({ product_id, published, date_to, date_from }: TGetProductsOfMonthForm) {
    this.date_to = dayjs(date_to).format(DateFormats.EUROPEAN_DEFAULT);
    this.date_from = dayjs(date_from).format(DateFormats.EUROPEAN_DEFAULT);
    this.published = published ?? '0';
    this.product_id = product_id ?? '';
  }
}

export default CreateProductDTO;
